<template>
  <div class="ly-table">
    <div class="table-header">
      <span class="table-title"
        >{{ $t("messages.titTblServiceContractInfo") }}
      </span>
    </div>
    <!-- 2022.03.14 추가 -->
    <div class="ly-flex">
      <div class="ly-sort ly-sort-his">
        <div class="sort-count">
          <p class="table-cell-all">
            {{ $t("messages.all") }} <span class="table-cell-count">{{ listCount }}</span
            >{{ $t("messages.unit") }}
          </p>
        </div>
      </div>
      <!-- <div class="ly-btn">
        <el-button plain size="small" type="excel" @click="excelDownload"
          >{{ $t("messages.btnExcel") }}<i class="icon-DownloadSimple"></i
        ></el-button>
      </div> -->
    </div>
    <!-- //2022.03.14 추가 -->
    <div class="table-body">
      <idc-table :tableData="tableData" :tableHeader="tableHeader" :height="300"/>
    </div>
  </div>
</template>

<script>
import IdcTable from "@/components/common/IdcTable";
import { getNow, commonExcelDownload } from "@/assets/js/common.js";

export default {
  props: {
    custId: {
      default: "",
    },
  },
  components: {
    IdcTable,
  },
  data() {
    return {
      tableData: [],
      searchSttusInfo : 'N'
    };
  },
  computed: {
    listCount() {
      return this.tableData.length;
    },
    tableHeader(){
      return [
        {
          prop: "idcCdHnglNm",
          label: "DC",
          width: 97,
        },
        {
          prop: "svcSttusCdHnglNm",
           // label: "서비스상태",
          label: this.$t("messages.lblServiceState"),
          width: 80,
        },
        {
          prop: "svcNo",
           //label: "서비스번호",
          label: this.$t("messages.lblServiceNumber"),
          width: 80,
        },
        {
          prop: "svcContId",
           //label: "서비스계약ID",
          label: this.$t("messages.lblSvcContId"),
          width: 136,
        },
        {
          prop: "svcTypeCdHnglNm",
          // label: "서비스",
          label: this.$t("messages.lblService"),
          width: 120,
        },
        {
          prop: "svcDtlIcisCdNm",
           // label: "상세구분",
          label: this.$t("messages.lblDtlClassificate"),
          width: 180,
        },
        
        {
          prop: "equipModelIcisCdNm",
           // label: "모델명",
          label: this.$t("messages.lblModelName"),
          width: 180,
        },
        {
          prop: "srvrMgmtNo",
          label: "S/N",
          width: 120,
        },
      ];
    }
  },
  created() {},
  mounted() {
    this.$store.dispatch("userInfoStore/getCustLoginCustInfo").then(data => {
      this.custId = data.custId;

      this.getWrkUseSvcListByCustId();
    });
  },
  methods: {
    getWrkUseSvcListByCustId() {
      console.log("getWrkUseSvcListByCustId=========>"+this.custId);
      this.$BIZ_SERVICE
        .post(this.$API_URLS.Svc.getWrkUseSvcListByCustId, {
          custId: this.custId,
          srchSvcSttusCd : this.searchSttusInfo,
        })
        .then((res) => {
          if (res.data) {
            this.tableData = res.data.resData;
            this.tableData.forEach((obj) => {
              obj.svcDtlIcisCdNm = obj.svcDtlIcisCd1Nm;

              if (obj.svcDtlIcisCd2Nm) {
                obj.svcDtlIcisCdNm = obj.svcDtlIcisCdNm + ' / ' + obj.svcDtlIcisCd2Nm;
              }

              if (obj.svcDtlIcisCd3Nm) {
                obj.svcDtlIcisCdNm = obj.svcDtlIcisCdNm + ' / ' + obj.svcDtlIcisCd3Nm;
              }

              if (obj.equipModelIcisCdNm) {
                obj.equipModelIcisCdNm = obj.equipModelIcisCdNm + '(' + obj.equipPtclModelIcisCdNm +')';
              }

              if (!obj.svcDtlIcisCdNm) obj.svcDtlIcisCdNm = '-';
              if (!obj.equipModelIcisCdNm) obj.equipModelIcisCdNm = '-';

              // 서버호스팅인 경우에만 서버관리번호표기
              if (!obj.srvrMgmtNo || obj.svcContIcisCd == '0771') obj.srvrMgmtNo = '-';
            });
          } else {
            this.tableData = [];
          }
        })
        .catch((error) => {})
        .finally(() => {});
    },
    excelDownload(){
      commonExcelDownload(
        this.$BIZ_SERVICE,
        this.$API_URLS.Com.excelDownloadByService, 
        this.$t('messages.titTblServiceContInfo') +"_" + getNow() + ".xlsx",
        "getSvcContList",
        this.tableHeader,
        { 
          custId : this.custId,
          srchSvcSttusCd : this.searchSttusInfo,
        }
      );
    }
  },
};
</script>

<style>

.ly-btn{
  padding-bottom:10px;
}
</style>
